import { render, staticRenderFns } from "./TabsDashboardFlightUploads.vue?vue&type=template&id=06c9c3e4&"
import script from "./TabsDashboardFlightUploads.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardFlightUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports